module.exports = __webpack_public_path__ + "img/verify_fail.b2476ed4.png";